module.exports = __webpack_public_path__ + "static/img/login_bg.49e39ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg.jpg
// module id = csAk
// module chunks = 1